import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "register-form-row" }
const _hoisted_3 = {
  value: '',
  selected: ""
}
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "form__arrow" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  value: '',
  selected: ""
}
const _hoisted_9 = ["value"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "form__arrow" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_12 = { class: "register-form-row" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  value: '',
  selected: ""
}
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "form__arrow" }, null, -1)
const _hoisted_17 = {
  key: 2,
  class: "error-msg"
}
const _hoisted_18 = {
  key: 3,
  class: "error-msg"
}
const _hoisted_19 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_20 = { class: "register-form-row" }
const _hoisted_21 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_24 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_25 = {
  key: 1,
  class: "error-msg"
}
const _hoisted_26 = { class: "register-form-row" }
const _hoisted_27 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_28 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_29 = { class: "register-form-checkboxes" }
const _hoisted_30 = {
  for: "marketing",
  class: "checkbox"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "checkbox-switch" }, null, -1)
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = {
  for: "marketing-group",
  class: "checkbox"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "checkbox-switch" }, null, -1)
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = {
  for: "terms",
  class: "checkbox"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "checkbox-switch" }, null, -1)
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = {
  key: 0,
  class: "error-msg error-msg--alt"
}
const _hoisted_40 = { class: "register-form-foot register-form-foot--alt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_ErrorPopin = _resolveComponent("ErrorPopin")!

  return (_openBlock(), _createElementBlock("form", {
    class: "register-form form",
    onSubmit: _cache[33] || (_cache[33] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("h3", {
      class: "register-form-title h4",
      innerHTML: _ctx.$t('register-form.step2-description')
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.country')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.country) = $event)),
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.country.$touch && _ctx.v$.country.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.country.$errors.length }),
          name: "country"
        }, [
          _createElementVNode("option", _hoisted_3, _toDisplayString(_ctx.$t('register-form.select')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (countryItem) => {
            return (_openBlock(), _createElementBlock("option", {
              key: countryItem.id,
              value: countryItem.id
            }, _toDisplayString(countryItem.name), 9, _hoisted_4))
          }), 128))
        ], 34), [
          [_vModelSelect, _ctx.country]
        ]),
        _hoisted_5,
        (_ctx.v$.country.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.v$.country.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.state')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state) = $event)),
          disabled: _ctx.country !== 230,
          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.state.$touch && _ctx.v$.state.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.state.$errors.length }),
          name: "state"
        }, [
          _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$t('register-form.select')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (stateItem) => {
            return (_openBlock(), _createElementBlock("option", {
              key: stateItem.id,
              value: stateItem.id
            }, _toDisplayString(stateItem.name), 9, _hoisted_9))
          }), 128))
        ], 42, _hoisted_7), [
          [_vModelSelect, _ctx.state]
        ]),
        _hoisted_10,
        (_ctx.v$.state.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.v$.state.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.city')), 1),
        (_ctx.country === 230)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _withDirectives(_createElementVNode("select", {
                disabled: _ctx.state === '' || !_ctx.cities.length,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cityId) = $event)),
                onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.cityId.$touch && _ctx.v$.cityId.$touch(...args))),
                class: _normalizeClass({ 'error': _ctx.v$.cityId.$errors.length }),
                name: "cityId"
              }, [
                _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t('register-form.select')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cities, (cityItem) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: cityItem.id,
                    value: cityItem.id
                  }, _toDisplayString(cityItem.name), 9, _hoisted_15))
                }), 128))
              ], 42, _hoisted_13), [
                [_vModelSelect, _ctx.cityId]
              ]),
              _hoisted_16
            ], 64))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.city) = $event)),
              onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$.city.$touch && _ctx.v$.city.$touch(...args))),
              class: _normalizeClass({ 'error': _ctx.v$.city.$errors.length }),
              type: "text",
              name: "city",
              maxlength: "255",
              required: "",
              spellcheck: "false",
              autocorrect: "off"
            }, null, 34)), [
              [
                _vModelText,
                _ctx.city,
                void 0,
                { trim: true }
              ]
            ]),
        (_ctx.country !== 230 && _ctx.v$.city.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.v$.city.$errors[0].$message), 1))
          : _createCommentVNode("", true),
        (_ctx.country === 230 && _ctx.v$.cityId.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.v$.cityId.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.address')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.address) = $event)),
          onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$.address.$touch && _ctx.v$.address.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.address.$errors.length }),
          type: "text",
          name: "address",
          maxlength: "255",
          required: "",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [
            _vModelText,
            _ctx.address,
            void 0,
            { trim: true }
          ]
        ]),
        (_ctx.v$.address.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.v$.address.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.zip')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.zip) = $event)),
          onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.v$.zip.$touch && _ctx.v$.zip.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.zip.$errors.length }),
          type: "text",
          name: "zip",
          minlength: "4",
          maxlength: "12",
          required: "",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [_vModelText, _ctx.zip]
        ]),
        (_ctx.v$.zip.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.v$.zip.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.date')), 1),
        _createElementVNode("div", {
          class: _normalizeClass([{ 'error': _ctx.v$.birthdayMonth.$errors.length || _ctx.v$.birthdayDay.$errors.length || _ctx.v$.birthdayYear.$errors.length }, "input-date"])
        }, [
          _withDirectives(_createElementVNode("input", {
            onKeypress: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args))),
            onKeyup: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onKeyUp && _ctx.onKeyUp(...args))),
            onChange: _cache[14] || (_cache[14] = ($event: any) => {if(parseInt(_ctx.birthdayMonth,10)<10)_ctx.birthdayMonth='0'+_ctx.birthdayMonth;}),
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.birthdayMonth) = $event)),
            onBlur: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.v$.birthdayMonth.$touch && _ctx.v$.birthdayMonth.$touch(...args))),
            type: "number",
            name: "birthdayMonth",
            min: "1",
            max: "12",
            size: "2",
            placeholder: "MM",
            required: "",
            minlength: "2",
            maxlength: "2",
            spellcheck: "false",
            autocorrect: "off"
          }, null, 544), [
            [_vModelText, _ctx.birthdayMonth]
          ]),
          _hoisted_22,
          _withDirectives(_createElementVNode("input", {
            onKeypress: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args))),
            onKeyup: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onKeyUp && _ctx.onKeyUp(...args))),
            onChange: _cache[19] || (_cache[19] = ($event: any) => {if(parseInt(_ctx.birthdayDay,10)<10)_ctx.birthdayDay='0'+_ctx.birthdayDay;}),
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.birthdayDay) = $event)),
            onBlur: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.v$.birthdayDay.$touch && _ctx.v$.birthdayDay.$touch(...args))),
            type: "number",
            name: "birthdayDay",
            min: "1",
            max: "31",
            size: "2",
            placeholder: "DD",
            required: "",
            minlength: "2",
            maxlength: "2",
            spellcheck: "false",
            autocorrect: "off"
          }, null, 544), [
            [_vModelText, _ctx.birthdayDay]
          ]),
          _hoisted_23,
          _withDirectives(_createElementVNode("input", {
            onKeypress: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args))),
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.birthdayYear) = $event)),
            onBlur: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.v$.birthdayYear.$touch && _ctx.v$.birthdayYear.$touch(...args))),
            type: "number",
            name: "birthdayYear",
            min: "1900",
            max: "3000",
            size: "4",
            placeholder: "YYYY",
            required: "",
            minlength: "4",
            maxlength: "4",
            spellcheck: "false",
            autocorrect: "off"
          }, null, 544), [
            [_vModelText, _ctx.birthdayYear]
          ])
        ], 2),
        (_ctx.v$.birthdayMonth.$errors.length || _ctx.v$.birthdayDay.$errors.length || _ctx.v$.birthdayYear.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.$t('error.date-invalid')), 1))
          : (_ctx.underage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.$t('error.date-underage')), 1))
            : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.establishment')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.establishment) = $event)),
          onBlur: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.v$.establishment.$touch && _ctx.v$.establishment.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.establishment.$errors.length }),
          type: "text",
          name: "establishment",
          maxlength: "255",
          required: "",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [_vModelText, _ctx.establishment]
        ]),
        (_ctx.v$.establishment.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.v$.establishment.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.position')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.position) = $event)),
          onBlur: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.v$.position.$touch && _ctx.v$.position.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.position.$errors.length }),
          type: "text",
          name: "position",
          maxlength: "255",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [
            _vModelText,
            _ctx.position,
            void 0,
            { trim: true }
          ]
        ]),
        (_ctx.v$.position.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.v$.position.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("label", _hoisted_30, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.marketing) = $event)),
          name: "marketing",
          id: "marketing",
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.marketing]
        ]),
        _hoisted_31,
        _createElementVNode("span", {
          class: "checkbox-label text",
          innerHTML: _ctx.$t('register-form.optin-barsmarts-offers')
        }, null, 8, _hoisted_32)
      ]),
      _createElementVNode("label", _hoisted_33, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.marketingGroup) = $event)),
          name: "marketing-group",
          id: "marketing-group",
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.marketingGroup]
        ]),
        _hoisted_34,
        _createElementVNode("span", {
          class: "checkbox-label text",
          innerHTML: _ctx.$t('register-form.optin-pernod-ricard')
        }, null, 8, _hoisted_35)
      ]),
      _createElementVNode("label", _hoisted_36, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.terms) = $event)),
          name: "terms",
          id: "terms",
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.terms]
        ]),
        _hoisted_37,
        _createElementVNode("span", {
          class: "checkbox-label text",
          innerHTML: _ctx.$t('register-form.optin-terms', {terms: '/terms', privacy: 'https://privacy.pernod-ricard-usa.com/'})
        }, null, 8, _hoisted_38)
      ]),
      (_ctx.isSubmit && !_ctx.terms)
        ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_ctx.$t('error.terms')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("button", {
        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.$emit('prevTab'))),
        type: "button",
        class: "link-secondary text-lg"
      }, _toDisplayString(_ctx.$t('register-form.back')), 1),
      _createVNode(_component_ButtonHover, {
        type: "submit",
        class: "button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('register-form.next')), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_ErrorPopin, { active: _ctx.errorRequest }, null, 8, ["active"])
  ], 32))
}